export default __webpack_public_path__ + "static/media/Acid_Plant_LE.ba6ef3ba.jpg";